export function searchModal() {
  document.addEventListener('DOMContentLoaded', () => {
    const modalEl = document.getElementById('siteSearchModal');
    if (!modalEl) return;

    const bsModal = bootstrap.Modal.getOrCreateInstance(modalEl);

    modalEl.addEventListener('shown.bs.modal', () => {
      const inp = modalEl.querySelector('input[name="s"]');
      inp && inp.focus();
      // se vuoi scurire la header mentre cerchi
      document.querySelector('.site-header')?.classList.add('full-color');
      document.documentElement.classList.add('no-scroll');
      document.body.classList.add('no-scroll');
    });

    modalEl.addEventListener('hidden.bs.modal', () => {
      document.querySelector('.site-header')?.classList.remove('full-color');
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
    });

    // opzionale: chiudi mega/offcanvas se erano aperti
    const closeEverything = () => {
      document.querySelectorAll('.mega-menu').forEach(m => m.classList.add('d-none'));
      document.querySelector('.menu-overlay')?.classList.add('d-none');
      document.querySelector('.menu-toggle')?.classList.remove('is-open');
    };
    modalEl.addEventListener('show.bs.modal', closeEverything);
  });
}